module.exports = __webpack_public_path__ + "img/chystam-party-detail-background.fdadfb3.svg";